module.exports = __webpack_public_path__ + "img/person_biking.c1cddee7.gif";